import accountMenu from 'v2/components/AccountMenu/translations/english';
import calendar from 'v2/components/Calendar/translations/english';
import chemicalEntrySection from 'v2/components/ChemicalEntrySection/translations/english';
import classicViewSwitchButton from 'v2/components/ClassicViewSwitchButton/translations/english';
import createCustomerModal from 'v2/components/CreateCustomerModal/translations/english';
import v2FreeTrialBanner from 'v2/components/FreeTrialBanner/translations/english';
import mapAddressSearch from 'v2/components/MapAddressSearch/translations/english';
import v2MultiSelectDropdown from 'v2/components/MultiSelectDropdown/translations/english';
import siteDropdown from 'v2/components/SiteDropdown/translations/english';
import siteForm from 'v2/components/SiteForm/translations/english';
import siteMultiSelectDropdown from 'v2/components/SiteMultiSelectDropdown/translations/english';
import v2SubscriptionBanner from 'v2/components/SubscriptionBanner/translations/english';
import tankMixTable from 'v2/components/TankMixTable/translations/english';
import workspaceEditForm from 'v2/components/WorkspaceEditForm/translations/english';
import v2ApplicatorCertificationForm from 'v2/layouts/AccountWorkspaceLayout/components/ApplicatorCertificationForm/translations/english';
import certificationsSection from 'v2/layouts/AccountWorkspaceLayout/components/CertificationsSection/translations/english';
import accountWorkspace from 'v2/layouts/AccountWorkspaceLayout/translations/english';
import v2AircraftForm from 'v2/layouts/OrganizationWorkspaceLayout/components/AircraftForm/translations/english';
import aircraftTable from 'v2/layouts/OrganizationWorkspaceLayout/components/AircraftTableSection/translations/english';
import v2ControllerForm from 'v2/layouts/OrganizationWorkspaceLayout/components/ControllerForm/translations/english';
import controllerTable from 'v2/layouts/OrganizationWorkspaceLayout/components/ControllerTableSection/translations/english';
import invitationsTable from 'v2/layouts/OrganizationWorkspaceLayout/components/InvitationsTableSection/translations/english';
import pesticideLicensesCard from 'v2/layouts/OrganizationWorkspaceLayout/components/OrganizationDetailsSection/components/PesticideLicensesCard/translations/english';
import v2PesticideLicenseForm from 'v2/layouts/OrganizationWorkspaceLayout/components/PesticideLicenseForm/translations/english';
import certificationStatesCell from 'v2/layouts/OrganizationWorkspaceLayout/components/UsersTableSection/components/CertificationStatesCell/translations/english';
import memberAccessCard from 'v2/layouts/OrganizationWorkspaceLayout/components/UsersTableSection/components/MemberAccessCard/translations/english';
import memberCertificationItem from 'v2/layouts/OrganizationWorkspaceLayout/components/UsersTableSection/components/MemberCertificationsCard/components/MemberCertificationItem/translations/english';
import memberCertificationsCard from 'v2/layouts/OrganizationWorkspaceLayout/components/UsersTableSection/components/MemberCertificationsCard/translations/english';
import memberDetails from 'v2/layouts/OrganizationWorkspaceLayout/components/UsersTableSection/components/MemberDetails/translations/english';
import usersTable from 'v2/layouts/OrganizationWorkspaceLayout/components/UsersTableSection/translations/english';
import organizationWorkspace from 'v2/layouts/OrganizationWorkspaceLayout/translations/english';
import createFaaReport from 'v2/pages/CreateFaaReportPage/translations/english';
import dashboard from 'v2/pages/DashboardPage/translations/english';
import v2EditAircraft from 'v2/pages/EditAircraftPage/translations/english';
import v2EditApplicatorCertification from 'v2/pages/EditApplicatorCertificationPage/translations/english';
import v2EditCertifications from 'v2/pages/EditCertificationsPage/translations/english';
import v2EditCompanyDetails from 'v2/pages/EditCompanyDetailsPage/translations/english';
import v2EditController from 'v2/pages/EditControllerPage/translations/english';
import v2EditPersonOfContact from 'v2/pages/EditPersonOfContactPage/translations/english';
import v2EditPesticideLicense from 'v2/pages/EditPesticideLicensePage/translations/english';
import v2EditUserDetails from 'v2/pages/EditUserDetailsPage/translations/english';
import flightGroupCreateDetailsTab from 'v2/pages/FlightsAndMapsPage/components/FlightGroupCreateDrawer/components/DetailsTab/translations/english';
import flightGroupCreateFilesTab from 'v2/pages/FlightsAndMapsPage/components/FlightGroupCreateDrawer/components/FilesTab/translations/english';
import flightGroupCreateReviewTab from 'v2/pages/FlightsAndMapsPage/components/FlightGroupCreateDrawer/components/ReviewTab/translations/english';
import flightGroupCreateDrawer from 'v2/pages/FlightsAndMapsPage/components/FlightGroupCreateDrawer/translations/english';
import flightGroupCreateMapModal from 'v2/pages/FlightsAndMapsPage/components/FlightGroupCreateMapModal/translations/english';
import flightGroupEditDrawer from 'v2/pages/FlightsAndMapsPage/components/FlightGroupEditDrawer/translations/english';
import flightUploadModal from 'v2/pages/FlightsAndMapsPage/components/FlightUploadModal/translations/english';
import flightsAndMapsPage from 'v2/pages/FlightsAndMapsPage/translations/english';
import v2InviteUser from 'v2/pages/InviteUserPage/translations/english';
import jobsPage from 'v2/pages/JobsPage/translations/english';
import v2NewAircraft from 'v2/pages/NewAircraftPage/translations/english';
import v2NewApplicatorCertification from 'v2/pages/NewApplicatorCertificationPage/translations/english';
import v2NewController from 'v2/pages/NewControllerPage/translations/english';
import v2NewPesticideLicense from 'v2/pages/NewPesticideLicensePage/translations/english';
import organizationMember from 'v2/pages/OrganizationMemberPage/translations/english';
import tankMixTotals from 'v2/pages/ProductUsageReportsPage/components/ProductUsageReportDrawer/components/StateReportingChemicalsTab/components/TankMixTotals/translations/english';
import productUsageReportStateReportingChemicalsTab from 'v2/pages/ProductUsageReportsPage/components/ProductUsageReportDrawer/components/StateReportingChemicalsTab/translations/english';
import productUsageReportsPage from 'v2/pages/ProductUsageReportsPage/translations/english';
import v2SitesPage from 'v2/pages/SitesPage/translations/english';
import workOrders from 'v2/pages/WorkOrdersPage/translations/english';

import accountDetails from 'components/AccountDetails/translations/english';
import accountTabs from 'components/AccountTabs/translations/english';
import alert from 'components/Alert/translations/english';
import asAppliedMapDetails from 'components/AsAppliedMapDetails/translations/english';
import asAppliedMapPdf from 'components/AsAppliedMapPDF/translations/english';
import authChecker from 'components/AuthChecker/translations/english';
import backNextButtons from 'components/BackNextButtons/translations/english';
import premierFeatureCallToAction from 'components/CallToActionBanner/components/PremierFeatureCallToAction/translations/english';
import companyDetailsForm from 'components/CompanyDetailsForm/translations/english';
import controllerForm from 'components/ControllerForm/translations/english';
import coordinateFields from 'components/CoordinateFields/translations/english';
import customerMapHeader from 'components/CustomerMapHeader/translations/english';
import damageReportFormMenu from 'components/DamageReportFormMenu/translations/english';
import downloadPdf from 'components/DownloadPDF/translations/english';
import downloadShapeFile from 'components/DownloadShapeFile/translations/english';
import equipmentDetails from 'components/EquipmentDetails/translations/english';
import equipmentTabs from 'components/EquipmentTabs/translations/english';
import faaListItemMenu from 'components/FaaListItemMenu/translations/english';
import faaReportListHeaders from 'components/FaaReportListHeaders/translations/english';
import faaReportsListPageLayoutHeader from 'components/FaaReportsListPageLayoutHeader/translations/english';
import filesMenu from 'components/FilesMenu/translations/english';
import flightGroupAddFlightsPageDrawer from 'components/FlightGroupAddFlightsPageDrawer/translations/english';
import flightGroupDrawer from 'components/FlightGroupDrawer/translations/english';
import flightGroupDrawerTitleSection from 'components/FlightGroupDrawerTitleSection/translations/english';
import flightGroupFlightItem from 'components/FlightGroupFlightItem/translations/english';
import flightGroupMapProcessorLoader from 'components/FlightGroupMapProcessorLoader/translations/english';
import flightLogListFilters from 'components/FlightLogListFilters/translations/english';
import flightLogListHeader from 'components/FlightLogListHeader/translations/english';
import flightLogListPageLayoutHeader from 'components/FlightLogListPageLayoutHeader/translations/english';
import flightLogListTabs from 'components/FlightLogListTabs/translations/english';
import flightLogMenu from 'components/FlightLogMenu/translations/english';
import flightReportOptionsMenu from 'components/FlightReportOptionsMenu/translations/english';
import flightTable from 'components/FlightTable/translations/english';
import formNavigationButtons from 'components/FormNavigationButtons/translations/english';
import invitationTable from 'components/InvitationTable/translations/english';
import job from 'components/Job/translations/english';
import jobs from 'components/Jobs/translations/english';
import legend from 'components/Legend/translations/english';
import listFooter from 'components/ListFooter/translations/english';
import locationSection from 'components/LocationSection/translations/english';
import mapMenu from 'components/MapMenu/translations/english';
import mapsListPageLayoutHeader from 'components/MapsListPageLayoutHeader/translations/english';
import monthPicker from 'components/MonthPicker/translations/english';
import multiSelectCards from 'components/MultiSelectCards/translations/english';
import myInformationForm from 'components/MyInformationForm/translations/english';
import applicationDetailsForm from 'components/NewProductUsageReport/ApplicationDetailsForm/translations/english';
import notesForm from 'components/NewProductUsageReport/NotesForm/translations/english';
import chemicalAppliedForm from 'components/NewProductUsageReport/ProductDetailsForm/ChemicalAppliedForm/translations/english';
import productDetailsForm from 'components/NewProductUsageReport/ProductDetailsForm/translations/english';
import onboardingLogout from 'components/OnboardingLogout/translations/english';
import opacitySlider from 'components/OpacitySlider/translations/english';
import operatorMapPoint from 'components/OperatorDetailsMapPoint/translations/english';
import organizationDetails from 'components/OrganizationDetails/translations/english';
import organizationSubscriptionDetails from 'components/OrganizationSubscriptionDetails/translations/english';
import organizationTabs from 'components/OrganizationTabs/translations/english';
import pilotsDropdown from 'components/PilotsDropdown/translations/english';
import applicationDetails from 'components/ProductUsageReport/ApplicationDetails/translations/english';
import productDetails from 'components/ProductUsageReport/ProductDetails/translations/english';
import productUsageReportNotes from 'components/ProductUsageReport/ProductUsageReportNotes/translations/english';
import productUsageReportFooter from 'components/ProductUsageReportFooter/translations/english';
import productUsageReportListPageLayoutHeader from 'components/ProductUsageReportListPageLayoutHeader/translations/english';
import productUsageReportMenu from 'components/ProductUsageReportMenu/translations/english';
import productUsageReportPdf from 'components/ProductUsageReportPDF/translations/english';
import productUsageReportSummaryDropdown from 'components/ProductUsageReportSummaryDropdown/translations/english';
import productUsageReportTable from 'components/ProductUsageReportTable/translations/english';
import quickBooksPdfInvoiceView from 'components/QuickBooksPdfInvoiceView/translations/english';
import sideBarContentContainer from 'components/ResourcePageNavigationButtons/translations/english';
import shareToFieldView from 'components/ShareToFieldView/translations/english';
import shareToJohnDeere from 'components/ShareToJohnDeere/translations/english';
import siteFooter from 'components/SiteFooter/translations/english';
import siteHeader from 'components/SiteHeader/translations/english';
import stripeSubscriptionSummary from 'components/StripeSubscriptionSummary/translations/english';
import teamDetails from 'components/TeamDetails/translations/english';
import teamDetailsTabs from 'components/TeamDetailsTabs/translations/english';
import userRolesTable from 'components/UserRolesTable/translations/english';
import versionAvailabilityBanner from 'components/VersionAvailabilityBanner/translations/english';
import withCharacterCount from 'components/WithCharacterCount/translations/english';
import workOrderFooter from 'components/WorkOrderFooter/translations/english';
import workOrderListPageLayoutHeader from 'components/WorkOrderListPageLayoutHeader/translations/english';
import workOrderMenu from 'components/WorkOrderMenu/translations/english';
import workOrderReportPDF from 'components/WorkOrderReportPDF/translations/english';
import workOrderTabs from 'components/WorkOrderTabs/translations/english';
import aamButton from 'components/buttons/AamButton/translations/english';
import backButton from 'components/buttons/BackButton/translations/english';
import copyButton from 'components/buttons/CopyButton/translations/english';
import flightLogBulkDeleteButton from 'components/buttons/FlightLogBulkDeleteButton/translations/english';
import flightLogFilterButton from 'components/buttons/FlightLogFilterButton/translations/english';
import mapDownloadButton from 'components/buttons/MapDownloadButton/translations/english';
import mapShareButton from 'components/buttons/MapShareButton/translations/english';
import refreshButton from 'components/buttons/RefreshButton/translations/english';
import saveReportButton from 'components/buttons/SaveReportButton/translations/english';
import aircraftCard from 'components/cards/AircraftCard/translations/english';
import baseEquipmentCard from 'components/cards/BaseEquipmentCard/translations/english';
import companyDetailsEditCard from 'components/cards/CompanyDetailsEditCard/translations/english';
import droneSelectCard from 'components/cards/DroneSelectCard/translations/english';
import equipmentMalfunctionFormCard from 'components/cards/EquipmentMalfunctionFormCard/translations/english';
import mapInfoCard from 'components/cards/MapInfoCard/translations/english';
import noAircraftCard from 'components/cards/NoAircraftCard/translations/english';
import noControllerCard from 'components/cards/NoControllerCard/translations/english';
import organizationCertificationEditCard from 'components/cards/OrganizationCertificationEditCard/translations/english';
import personOfContactEditCard from 'components/cards/PersonOfContactEditCard/translations/english';
import productUsageReportCard from 'components/cards/ProductUsageReportCard/translations/english';
import productUsageReportSummaryCard from 'components/cards/ProductUsageReportSummaryCard/translations/english';
import stripeSubscriptionCard from 'components/cards/StripeSubscriptionCard/translations/english';
import userDetailsEditCard from 'components/cards/UserDetailsEditCard/translations/english';
import alertLabel from 'components/colored-labels/AlertLabel/translations/english';
import appliedLabel from 'components/colored-labels/AppliedLabel/translations/english';
import asFlownLabel from 'components/colored-labels/AsFlownLabel/translations/english';
import canceledLabel from 'components/colored-labels/CanceledLabel/translations/english';
import completeLabel from 'components/colored-labels/CompleteLabel/translations/english';
import coveredLabel from 'components/colored-labels/CoveredLabel/translations/english';
import csvLabel from 'components/colored-labels/CsvLabel/translations/english';
import dryLabel from 'components/colored-labels/DryLabel/translations/english';
import kmlLabel from 'components/colored-labels/KmlLabel/translations/english';
import pendingLabel from 'components/colored-labels/PendingLabel/translations/english';
import quickBooksLabel from 'components/colored-labels/QuickBooksLabel/translations/english';
import scheduledLabel from 'components/colored-labels/ScheduledLabel/translations/english';
import startedLabel from 'components/colored-labels/StartedLabel/translations/english';
import successLabel from 'components/colored-labels/SuccessLabel/translations/english';
import syncedLabel from 'components/colored-labels/SyncedLabel/translations/english';
import uploadedLabel from 'components/colored-labels/UploadedLabel/translations/english';
import wetLabel from 'components/colored-labels/WetLabel/translations/english';
import droneReportContainer from 'components/containers/DroneReportContainer/translations/english';
import mapListContainer from 'components/containers/MapListContainer/translations/english';
import addressFields from 'components/deprecating/AddressFields/translations/english';
import aircraftForm from 'components/deprecating/AircraftForm/translations/english';
import cityField from 'components/deprecating/CityField/translations/english';
import cityInput from 'components/deprecating/CityInput/translations/english';
import companyContactFields from 'components/deprecating/CompanyContactFields/translations/english';
import companyNameField from 'components/deprecating/CompanyNameField/translations/english';
import costSectionForm from 'components/deprecating/CreateInvoicePage/components/CostSectionForm/translations/english';
import invoiceHeaderForm from 'components/deprecating/CreateInvoicePage/components/InvoiceHeaderForm/translations/english';
import invoiceServiceItem from 'components/deprecating/CreateInvoicePage/components/InvoiceServiceItem/translations/english';
import invoiceServiceItemList from 'components/deprecating/CreateInvoicePage/components/InvoiceServiceItemsList/translations/english';
import subtotalSectionForm from 'components/deprecating/CreateInvoicePage/components/SubtotalSectionForm/translations/english';
import createInvoicePage from 'components/deprecating/CreateInvoicePage/translations/english';
import deprecatingCustomerComboboxField from 'components/deprecating/CustomerComboboxField/translations/english';
import emailField from 'components/deprecating/EmailField/translations/english';
import deprecatingQuickbooksServiceItemsDropdownField from 'components/deprecating/QuickbooksServiceItemsDropdownField/translations/english';
import deprecatingQuickbooksTermsDropdownField from 'components/deprecating/QuickbooksTermsDropdownField/translations/english';
import workOrderNumberInput from 'components/deprecating/WorkOrderNumberInput/translations/english';
import acresFlownDropdownField from 'components/fields/AcresFlownDropdownField/translations/english';
import addressOneField from 'components/fields/AddressOneField/translations/english';
import applicatorDropdown from 'components/fields/ApplicatorDropdown/translations/english';
import coaField from 'components/fields/Coafield/translations/english';
import customerComboboxField from 'components/fields/CustomerComboboxField/translations/english';
import droneDropdown from 'components/fields/DroneDropdown/translations/english';
import exemptionNumberField from 'components/fields/ExemptionNumberField/translations/english';
import exemptionDocketNumberField from 'components/fields/ExmeptionDocketNumberField/translations/english';
import flightGroupNameField from 'components/fields/FlightGroupNameField/translations/english';
import hoursFlownDropdownField from 'components/fields/HoursFlownDropdownField/translations/english';
import mapTypeDropdown from 'components/fields/MapTypeDropdown/translations/english';
import multiSelectDropdown from 'components/fields/MultiSelectDropdown/translations/english';
import quickbooksDiscountTypeDropdownField from 'components/fields/QuickbooksDiscountTypeDropdownField/translations/english';
import quickbooksServiceItemsDropdownField from 'components/fields/QuickbooksServiceItemsDropdownField/translations/english';
import quickbooksTaxCodesDropdownField from 'components/fields/QuickbooksTaxCodesDropdownField/translations/english';
import quickbooksTermsDropdownField from 'components/fields/QuickbooksTermsDropdownField/translations/english';
import textField from 'components/fields/TextField/translations/english';
import timeZoneField from 'components/fields/TimeZoneField/translations/english';
import userRolesDropdownField from 'components/fields/UserRolesDropdownField/translations/english';
import workOrderDropdown from 'components/fields/WorkOrderDropdown/translations/english';
import yearsOfServiceDropdownField from 'components/fields/YearsOfServiceDropdownField/translations/english';
import addressForm from 'components/forms/AddressForm/translations/english';
import customerAddressForm from 'components/forms/CustomerAddressForm/translations/english';
import customerForm from 'components/forms/CustomerForm/translations/english';
import emailInvoiceForm from 'components/forms/EmailInvoiceForm/translations/english';
import inviteUserForm from 'components/forms/InviteUserForm/translations/english';
import malfunctionReportForm from 'components/forms/MalfunctionReportForm/translations/english';
import operatorMapCompanyDetailsForm from 'components/forms/OperatorMapCompanyDetailsForm/translations/english';
import operatorMapLocationDetailsForm from 'components/forms/OperatorMapLocationDetailsForm/translations/english';
import operatorMapServiceDetailsForm from 'components/forms/OperatorMapServiceDetailsForm/translations/english';
import userDetailsForm from 'components/forms/UserDetailsForm/translations/english';
import addFarmButton from 'components/iconTextButtons/AddFarmButton/translations/english';
import addFieldButton from 'components/iconTextButtons/AddFieldButton/translations/english';
import addGrowerButton from 'components/iconTextButtons/AddGrowerButton/translations/english';
import addressOneInput from 'components/inputs/AddressOneInput/translations/english';
import addressTwoInput from 'components/inputs/AddressTwoInput/translations/english';
import companyNameInput from 'components/inputs/CompanyNameInput/translations/english';
import componentInput from 'components/inputs/ComponentInput/translations/english';
import damageTypeDropdown from 'components/inputs/DamageTypeDropdown/translations/english';
import faaReferenceNumberInput from 'components/inputs/FaaReferenceNumberInput/translations/english';
import formFileUpload from 'components/inputs/FormFileUpload/translations/english';
import formMultiFileUploadFileListContainer from 'components/inputs/MultiFileUpload/components/FileListContainer/translations/english';
import formMultiFileUploadFileListHeader from 'components/inputs/MultiFileUpload/components/FileListHeader/translations/english';
import formMultiFileUploadFileListRow from 'components/inputs/MultiFileUpload/components/FileListRow/translations/english';
import multiFileUpload from 'components/inputs/MultiFileUpload/translations/english';
import productUsageReportDropdown from 'components/inputs/ProductUsageReportDropdown/translations/english';
import textInputWithValidation from 'components/inputs/TextInputWithValidation/translations/english';
import yesNoDropdown from 'components/inputs/YesNoDropdown/translations/english';
import helpLink from 'components/links/HelpLink/translations/english';
import flightGroupListItem from 'components/list-items/FlightGroupListItem/translations/english';
import flightLogListItem from 'components/list-items/FlightLogListItem/translations/english';
import mapListItem from 'components/list-items/MapListItem/translations/english';
import aircraftList from 'components/lists/AircraftList/translations/english';
import controllerList from 'components/lists/ControllerList/translations/english';
import flightGroupList from 'components/lists/FlightGroupList/translations/english';
import flightList from 'components/lists/FlightList/translations/english';
import useFlightReportDelete from 'components/lists/FlightReportList/hooks/useFlightReportDelete/translations/english';
import useFlightReportUpdate from 'components/lists/FlightReportList/hooks/useFlightReportUpdate/translations/english';
import flightReportList from 'components/lists/FlightReportList/translations/english';
import invoiceList from 'components/lists/InvoiceList/translations/english';
import mapList from 'components/lists/MapList/translations/english';
import organizationList from 'components/lists/OrganizationList/translations/english';
import constructionModal from 'components/modals/ConstructionModal/translations/english';
import continueModal from 'components/modals/ContinueModal/translations/english';
import deleteConfirmationModal from 'components/modals/DeleteConfirmationModal/translations/english';
import disconnectConfirmationModal from 'components/modals/DisconnectConfirmationModal/translations/english';
import editUserRolesModal from 'components/modals/EditUserRolesModal/translations/english';
import exitWorkOrderModal from 'components/modals/ExitWorkOrderModal/translations/english';
import exportAsAppliedMapModal from 'components/modals/ExportAsAppliedMapModal/translations/english';
import faaReportDeleteConfirmationModal from 'components/modals/FaaReportDeleteConfirmationModal/translations/english';
import flightGroupAsAppliedMapRequestModal from 'components/modals/FlightGroupAsAppliedMapRequestModal/translations/english';
import flightLogDeleteConfirmationModal from 'components/modals/FlightLogDeleteConfirmationModal/translations/english';
import flightLogDeleteErrorModal from 'components/modals/FlightLogDeleteErrorModal/translations/english';
import flightReportDeleteModal from 'components/modals/FlightReportDeleteModal/translations/english';
import johnDeereExportModal from 'components/modals/JohnDeereExportModal/translations/english';
import newProductUsageReportModal from 'components/modals/NewProductUsageReportModal/translations/english';
import productUsageReportDeleteConfirmationModal from 'components/modals/ProductUsageReportDeleteConfirmationModal/translations/english';
import quickBooksImportConfirmationModal from 'components/modals/QuickBooksImportConfirmationModal/translations/english';
import quickbooksWarningModal from 'components/modals/QuickbooksWarningModal/translations/english';
import saveChangesModal from 'components/modals/SaveChangesModal/translations/english';
import pdfCopyright from 'components/pdf/Copyright/translations/english';
import pdfDataValue from 'components/pdf/DataValue/translations/english';
import pdfPageNumberOfN from 'components/pdf/PageNumberOfN/translations/english';
import pdfPageNumberText from 'components/pdf/PageNumberText/translations/english';
import pdfProductUsageReportApplication from 'components/pdf/ProductUsageReportApplication/translations/english';
import pdfProductUsageReportApplicationDetails from 'components/pdf/ProductUsageReportApplicationDetails/translations/english';
import pdfProductUsageReportAppliedMixtureBasis from 'components/pdf/ProductUsageReportAppliedMixtureBasis/translations/english';
import pdfProductUsageReportBusinessLicensee from 'components/pdf/ProductUsageReportBusinessLicensee/translations/english';
import pdfProductUsageReportCustomer from 'components/pdf/ProductUsageReportCustomer/translations/english';
import pdfProductUsageReportGrower from 'components/pdf/ProductUsageReportGrower/translations/english';
import pdfProductUsageReportLabelDocuments from 'components/pdf/ProductUsageReportLabelDocuments/translations/english';
import pdfProductUsageReportLabelRestrictions from 'components/pdf/ProductUsageReportLabelRestrictions/translations/english';
import pdfProductUsageReportNotes from 'components/pdf/ProductUsageReportNotes/translations/english';
import pdfProductUsageReportPageFooter from 'components/pdf/ProductUsageReportPageFooter/translations/english';
import pdfProductUsageReportPageHeader from 'components/pdf/ProductUsageReportPageHeader/translations/english';
import pdfProductUsageReportProductDetails from 'components/pdf/ProductUsageReportProductDetails/translations/english';
import pdfProductUsageReportProductsApplied from 'components/pdf/ProductUsageReportProductsApplied/translations/english';
import pdfProductUsageReportTankMixComposition from 'components/pdf/ProductUsageReportTankMixComposition/translations/english';
import pdfProductUsageReportTitleBlock from 'components/pdf/ProductUsageReportTitleBlock/translations/english';
import pdfWorkOrderApplicationSiteBoundary from 'components/pdf/WorkOrderApplicationSiteBoundary/translations/english';
import pdfWorkOrderApplicationSites from 'components/pdf/WorkOrderApplicationSites/translations/english';
import pdfWorkOrderChemicalInformation from 'components/pdf/WorkOrderChemicalInformation/translations/english';
import pdfWorkOrderCustomerGrower from 'components/pdf/WorkOrderCustomerGrower/translations/english';
import pdfWorkOrderDetails from 'components/pdf/WorkOrderDetails/translations/english';
import pdfWorkOrderNotes from 'components/pdf/WorkOrderNotes/translations/english';
import pdfWorkOrderSiteCommodity from 'components/pdf/WorkOrderSiteCommodity/translations/english';
import pdfInvoiceApplicationDateColumn from 'components/pdf/invoice/InvoiceApplicationDateColumn/translations/english';
import pdfInvoiceBillingColumn from 'components/pdf/invoice/InvoiceBillingColumn/translations/english';
import pdfInvoiceCompanyColumn from 'components/pdf/invoice/InvoiceCompanyColumn/translations/english';
import pdfInvoiceDetailsColumn from 'components/pdf/invoice/InvoiceDetailsColumn/translations/english';
import pdfInvoicePageFooter from 'components/pdf/invoice/InvoicePageFooter/translations/english';
import pdfInvoicePageHeader from 'components/pdf/invoice/InvoicePageHeader/translations/english';
import pdfInvoiceThirdPartyWorkOrderColumn from 'components/pdf/invoice/InvoiceThirdPartyWorkOrderColumn/translations/english';
import pdfInvoiceWorkOrderColumn from 'components/pdf/invoice/InvoiceWorkOrderColumn/translations/english';
import pdfInvoiceTableChemicalCostRow from 'components/pdf/invoice/table/InvoiceTableChemicalCostRow/translations/english';
import pdfInvoiceTableFieldFlatFeeRow from 'components/pdf/invoice/table/InvoiceTableFieldFlatFeeRow/translations/english';
import pdfInvoiceTableFieldRateRow from 'components/pdf/invoice/table/InvoiceTableFieldRateRow/translations/english';
import pdfInvoiceTableFooter from 'components/pdf/invoice/table/InvoiceTableFooter/translations/english';
import pdfInvoiceTableHeader from 'components/pdf/invoice/table/InvoiceTableHeader/translations/english';
import pdfInvoiceTableOtherItemRows from 'components/pdf/invoice/table/InvoiceTableOtherItemRows/translations/english';
import pdfInvoiceTableTaxRow from 'components/pdf/invoice/table/InvoiceTableTaxRow/translations/english';
import workOrderApplicationSiteFields from 'components/work-order/ApplicationSite/components/ApplicationSiteFields/translations/english';
import workOrderApplicationSite from 'components/work-order/ApplicationSite/translations/english';
import workOrderChemicalInformationFields from 'components/work-order/ChemicalInformation/components/ChemicalInformationFields/translations/english';
import workOrderChemicalInformation from 'components/work-order/ChemicalInformation/translations/english';
import workOrderCustomerInformation from 'components/work-order/CustomerInformation/translations/english';
import workOrderDetails from 'components/work-order/Details/translations/english';
import workOrderGrowerInformation from 'components/work-order/GrowerInformation/translations/english';
import workOrderInvoiceAssistant from 'components/work-order/InvoiceAssistant/translations/english';
import workOrderNotes from 'components/work-order/Notes/translations/english';
import workOrderSiteCommodity from 'components/work-order/SiteCommodity/translations/english';
import workOrderSidebar from 'components/work-order/WorkOrderSidebar/translations/engilsh';

import useAccount from 'hooks/useAccount/translations/english';
import useApplicator from 'hooks/useApplicator/translations/english';
import useDdm from 'hooks/useDdm/translations/english';
import useDroneData from 'hooks/useDroneData/translations/english';
import useEaVision from 'hooks/useEaVision/translations/english';
import useFetch from 'hooks/useFetch/translations/english';
import useFlightGroups from 'hooks/useFlightGroups/translations/english';
import useInviteUserToOrganization from 'hooks/useInviteUserToOrganization/translations/english';
import useOperators from 'hooks/useOperators/translations/english';
import useQuickBooksConnection from 'hooks/useQuickbooks/hooks/useQuickbooksConnection/translations/english';
import useQuickbooksInvoice from 'hooks/useQuickbooks/hooks/useQuickbooksInvoice/translations/english';
import useStripe from 'hooks/useStripe/translations/english';
import useUserRoles from 'hooks/useUserRoles/translations/english';

import useAccountTabs from 'pages/AccountDrawerPage/AccountDrawer/hooks/useAccountTabs/translations/english';
import myAccount from 'pages/AccountDrawerPage/AccountDrawerTabs/MyAccount/translations/english';
import subscriptions from 'pages/AccountDrawerPage/AccountDrawerTabs/Subscriptions/translations/english';
import invitationsTab from 'pages/AccountDrawerPage/AccountDrawerTabs/Users/components/InvitationsTab/translations/english';
import usersTab from 'pages/AccountDrawerPage/AccountDrawerTabs/Users/components/UsersTab/translations/english';
import users from 'pages/AccountDrawerPage/AccountDrawerTabs/Users/translations/english';
import asAppliedMapsPage from 'pages/AsAppliedMapPage/translations/english';
import asAppliedMapResultsPage from 'pages/AsAppliedMapResultsPage/translations/english';
import certificatesAndExemptionsPage from 'pages/CertificatesAndExemptionsPage/translations/english';
import createCustomerDrawer from 'pages/CreateCustomerPage/CreateCustomersDrawer/translations/english';
import customerDeleteButton from 'pages/CreateCustomerPage/CustomerDeleteButton/translations/english';
import createCustomerPage from 'pages/CreateCustomerPage/translations/english';
import createFaaReportCompanyDetails from 'pages/CreateFaaReportPage/components/CompanyDetails/translations/english';
import flightDetails from 'pages/CreateFaaReportPage/components/FlightDetails/translations/english';
import createFaaReportOperationDetails from 'pages/CreateFaaReportPage/components/OperationDetails/translations/english';
import uasTypeAndModel from 'pages/CreateFaaReportPage/components/UasTypeAndModel/translations/english';
import createFaaReportPage from 'pages/CreateFaaReportPage/translations/english';
import createFlightGroupPage from 'pages/CreateFlightGroupPage/translations/english';
import customerList from 'pages/CustomersPage/CustomerList/translations/english';
import customersDrawer from 'pages/CustomersPage/CustomersDrawer/translations/english';
import editAircraftPage from 'pages/EditAircraftPage/translations/english';
import editCompanyDetailsPage from 'pages/EditCompanyDetailsPage/translations/english';
import editControllerPage from 'pages/EditControllerPage/translations/english';
import editPersonOfContactPage from 'pages/EditPersonOfContactPage/translations/english';
import editUserDetailsPage from 'pages/EditUserDetailsPage/translations/english';
import faaReportsPage from 'pages/FaaReportsPage/translations/english';
import flghtGroupAddFlightPage from 'pages/FlightGroupAddFlightPage/translations/english';
import flightGroupFlightUploadPage from 'pages/FlightGroupFlightUploadPage/translations/english';
import flightLogPage from 'pages/FlightLogPage/translations/english';
import flightPage from 'pages/FlightPage/translations/english';
import generateAsAppliedMapApplicationDetailsForm from 'pages/GenerateAsAppliedMapPage/components/ApplicationDetailsForm/translations/english';
import flightLogForm from 'pages/GenerateAsAppliedMapPage/components/FlightLogForm/translations/english';
import flightOverview from 'pages/GenerateAsAppliedMapPage/components/FlightOverview/translations/english';
import mapProcessorLoader from 'pages/GenerateAsAppliedMapPage/components/MapProcessorLoader/translations/english';
import generateAsAppliedMapPage from 'pages/GenerateAsAppliedMapPage/translations/english';
import homePage from 'pages/HomePage/translations/english';
import invoicePreviewPage from 'pages/InvoicePreviewPage/translations/english';
import johnDeereRedirect from 'pages/JohnDeereRedirectPage/translations/english';
import ddmConnectionListItem from 'pages/ManageConnectionsPage/components/DdmConnectionListItem/translations/english';
import eaVisionConnectionListItem from 'pages/ManageConnectionsPage/components/EaVisionConnectionListItem/translations/english';
import fieldViewConnectionListItem from 'pages/ManageConnectionsPage/components/FieldViewConnectionListItem/translations/english';
import johnDeereConnectionListItem from 'pages/ManageConnectionsPage/components/JohnDeereConnectionListItem/translations/english';
import quickBooksConnectionListItem from 'pages/ManageConnectionsPage/components/QuickBooksConnectionListItem/translations/english';
import manageConnectionsPage from 'pages/ManageConnectionsPage/translations/english';
import newAircraftPage from 'pages/NewAircraftPage/translations/english';
import newControllerPage from 'pages/NewControllerPage/translations/english';
import newProductUsageReportPage from 'pages/NewProductUsageReportPage/translations/english';
import operatorTileHomePageDrawer from 'pages/OperatorTileHomePage/OperatorTileHomePageDrawer/translations/english';
import operatorTileOverviewDrawer from 'pages/OperatorTileOverviewPage/components/OperatorTileOverviewDrawer/translations/english';
import joinServiceProviderMapDrawer from 'pages/OperatorTileSignUpFlowPage/components/JoinServiceProviderMapDrawer/translations/english';
import operatorTileSignUpFlowPage from 'pages/OperatorTileSignUpFlowPage/translations/english';
import productUsageReportListPage from 'pages/ProductUsageReportListPage/translations/english';
import productUsageReportPage from 'pages/ProductUsageReportPage/translations/english';
import sendInvoicePage from 'pages/SendInvoicePage/translations/english';
import siteListItem from 'pages/SitesPage/SiteListPanel/SiteListItem/translations/english';
import stripeConfirmationRedirectPage from 'pages/StripeConfirmationRedirectPage/translations/english';
import applicationDetailsTab from 'pages/UploadFlightLogPage/components/ApplicationDetailsTab/translations/english';
import uploadedFileOptions from 'pages/UploadFlightLogPage/components/DjiFileUploadTab/components/UploadedFileOptions/translations/english';
import djiFileUploadTab from 'pages/UploadFlightLogPage/components/DjiFileUploadTab/translations/english';
import xagFileUploadTab from 'pages/UploadFlightLogPage/components/XagFileUploadTab/translations/english';
import uploadFlightLogPage from 'pages/UploadFlightLogPage/translations/english';
import verifyAccountPage from 'pages/VerifyAccountPage/translations/english';
import verifyEmailPage from 'pages/VerifyEmailPage/translations/english';
import verifyOrganizationPage from 'pages/VerifyOrganizationPage/translations/english';
import workOrderPage from 'pages/WorkOrderPage/translations/english';
import workOrderReportPage from 'pages/WorkOrderReportPage/translations/english';
import apiErrorPage from 'pages/errors/ApiErrorPage/translations/english';
import badPathErrorPage from 'pages/errors/BadPathErrorPage/translations/english';
import badRequestErrorPage from 'pages/errors/BadRequestErrorPage/translations/english';
import errorPage from 'pages/errors/ErrorPage/translations/english';
import notFoundErrorPage from 'pages/errors/NotFoundErrorPage/translations/english';
import timeoutErrorPage from 'pages/errors/TimeoutErrorPage/translations/english';
import unknownErrorPage from 'pages/errors/UnknownErrorPage/translations/english';

export const TRANSLATIONS_EN = {
    aamButton,
    accountDetails,
    accountMenu,
    accountTabs,
    accountWorkspace,
    acresFlownDropdownField,
    addFarmButton,
    addFieldButton,
    addGrowerButton,
    addressFields,
    addressForm,
    addressOneField,
    addressOneInput,
    addressTwoInput,
    aircraftCard,
    aircraftForm,
    aircraftList,
    aircraftTable,
    alert,
    alertLabel,
    apiErrorPage,
    applicationDetails,
    applicationDetailsForm,
    applicationDetailsTab,
    applicatorDropdown,
    appliedLabel,
    asAppliedMapDetails,
    asAppliedMapPdf,
    asAppliedMapResultsPage,
    asAppliedMapsPage,
    asFlownLabel,
    authChecker,
    backButton,
    backNextButtons,
    badPathErrorPage,
    badRequestErrorPage,
    baseEquipmentCard,
    calendar,
    canceledLabel,
    certificatesAndExemptionsPage,
    certificationStatesCell,
    certificationsSection,
    chemicalAppliedForm,
    chemicalEntrySection,
    cityField,
    cityInput,
    classicViewSwitchButton,
    coaField,
    companyContactFields,
    companyDetailsEditCard,
    companyDetailsForm,
    companyNameField,
    companyNameInput,
    completeLabel,
    componentInput,
    constructionModal,
    continueModal,
    controllerForm,
    controllerList,
    controllerTable,
    coordinateFields,
    copyButton,
    costSectionForm,
    coveredLabel,
    createCustomerDrawer,
    createCustomerModal,
    createCustomerPage,
    createFaaReport,
    createFaaReportCompanyDetails,
    createFaaReportOperationDetails,
    createFaaReportPage,
    createFlightGroupPage,
    createInvoicePage,
    csvLabel,
    customerAddressForm,
    customerComboboxField,
    customerDeleteButton,
    customerForm,
    customerList,
    customerMapHeader,
    customersDrawer,
    damageReportFormMenu,
    damageTypeDropdown,
    dashboard,
    ddmConnectionListItem,
    deleteConfirmationModal,
    deprecatingCustomerComboboxField,
    deprecatingQuickbooksServiceItemsDropdownField,
    deprecatingQuickbooksTermsDropdownField,
    disconnectConfirmationModal,
    djiFileUploadTab,
    downloadPdf,
    downloadShapeFile,
    droneDropdown,
    droneReportContainer,
    droneSelectCard,
    dryLabel,
    eaVisionConnectionListItem,
    editAircraftPage,
    editCompanyDetailsPage,
    editControllerPage,
    editPersonOfContactPage,
    editUserDetailsPage,
    editUserRolesModal,
    emailField,
    emailInvoiceForm,
    equipmentDetails,
    equipmentMalfunctionFormCard,
    equipmentTabs,
    errorPage,
    exemptionDocketNumberField,
    exemptionNumberField,
    exitWorkOrderModal,
    exportAsAppliedMapModal,
    faaListItemMenu,
    faaReferenceNumberInput,
    faaReportDeleteConfirmationModal,
    faaReportListHeaders,
    faaReportsListPageLayoutHeader,
    faaReportsPage,
    fieldViewConnectionListItem,
    filesMenu,
    flghtGroupAddFlightPage,
    flightDetails,
    flightGroupAddFlightsPageDrawer,
    flightGroupAsAppliedMapRequestModal,
    flightGroupCreateDetailsTab,
    flightGroupCreateDrawer,
    flightGroupCreateFilesTab,
    flightGroupCreateMapModal,
    flightGroupCreateReviewTab,
    flightGroupDrawer,
    flightGroupDrawerTitleSection,
    flightGroupEditDrawer,
    flightGroupFlightItem,
    flightGroupFlightUploadPage,
    flightGroupList,
    flightGroupListItem,
    flightGroupMapProcessorLoader,
    flightGroupNameField,
    flightList,
    flightLogBulkDeleteButton,
    flightLogDeleteConfirmationModal,
    flightLogDeleteErrorModal,
    flightLogFilterButton,
    flightLogForm,
    flightLogListFilters,
    flightLogListHeader,
    flightLogListItem,
    flightLogListPageLayoutHeader,
    flightLogListTabs,
    flightLogMenu,
    flightLogPage,
    flightOverview,
    flightPage,
    flightReportDeleteModal,
    flightReportList,
    flightReportOptionsMenu,
    flightTable,
    flightUploadModal,
    flightsAndMapsPage,
    formFileUpload,
    formMultiFileUploadFileListContainer,
    formMultiFileUploadFileListHeader,
    formMultiFileUploadFileListRow,
    formNavigationButtons,
    generateAsAppliedMapApplicationDetailsForm,
    generateAsAppliedMapPage,
    helpLink,
    homePage,
    hoursFlownDropdownField,
    invitationTable,
    invitationsTab,
    invitationsTable,
    inviteUserForm,
    invoiceHeaderForm,
    invoiceList,
    invoicePreviewPage,
    invoiceServiceItem,
    invoiceServiceItemList,
    job,
    jobs,
    jobsPage,
    johnDeereConnectionListItem,
    johnDeereExportModal,
    johnDeereRedirect,
    joinServiceProviderMapDrawer,
    kmlLabel,
    legend,
    listFooter,
    locationSection,
    malfunctionReportForm,
    manageConnectionsPage,
    mapAddressSearch,
    mapDownloadButton,
    mapInfoCard,
    mapList,
    mapListContainer,
    mapListItem,
    mapMenu,
    mapProcessorLoader,
    mapShareButton,
    mapTypeDropdown,
    mapsListPageLayoutHeader,
    memberAccessCard,
    memberCertificationItem,
    memberCertificationsCard,
    memberDetails,
    monthPicker,
    multiFileUpload,
    multiSelectCards,
    multiSelectDropdown,
    myAccount,
    myInformationForm,
    newAircraftPage,
    newControllerPage,
    newProductUsageReportModal,
    newProductUsageReportPage,
    noAircraftCard,
    noControllerCard,
    notFoundErrorPage,
    notesForm,
    onboardingLogout,
    opacitySlider,
    operatorMapCompanyDetailsForm,
    operatorMapLocationDetailsForm,
    operatorMapPoint,
    operatorMapServiceDetailsForm,
    operatorTileHomePageDrawer,
    operatorTileOverviewDrawer,
    operatorTileSignUpFlowPage,
    organizationCertificationEditCard,
    organizationDetails,
    organizationList,
    organizationMember,
    organizationSubscriptionDetails,
    organizationTabs,
    organizationWorkspace,
    pdfCopyright,
    pdfDataValue,
    pdfInvoiceApplicationDateColumn,
    pdfInvoiceBillingColumn,
    pdfInvoiceCompanyColumn,
    pdfInvoiceDetailsColumn,
    pdfInvoicePageFooter,
    pdfInvoicePageHeader,
    pdfInvoiceTableChemicalCostRow,
    pdfInvoiceTableFieldFlatFeeRow,
    pdfInvoiceTableFieldRateRow,
    pdfInvoiceTableFooter,
    pdfInvoiceTableHeader,
    pdfInvoiceTableOtherItemRows,
    pdfInvoiceTableTaxRow,
    pdfInvoiceThirdPartyWorkOrderColumn,
    pdfInvoiceWorkOrderColumn,
    pdfPageNumberOfN,
    pdfPageNumberText,
    pdfProductUsageReportApplication,
    pdfProductUsageReportApplicationDetails,
    pdfProductUsageReportAppliedMixtureBasis,
    pdfProductUsageReportBusinessLicensee,
    pdfProductUsageReportCustomer,
    pdfProductUsageReportGrower,
    pdfProductUsageReportLabelDocuments,
    pdfProductUsageReportLabelRestrictions,
    pdfProductUsageReportNotes,
    pdfProductUsageReportPageFooter,
    pdfProductUsageReportPageHeader,
    pdfProductUsageReportProductDetails,
    pdfProductUsageReportProductsApplied,
    pdfProductUsageReportTankMixComposition,
    pdfProductUsageReportTitleBlock,
    pdfWorkOrderApplicationSiteBoundary,
    pdfWorkOrderApplicationSites,
    pdfWorkOrderChemicalInformation,
    pdfWorkOrderCustomerGrower,
    pdfWorkOrderDetails,
    pdfWorkOrderNotes,
    pdfWorkOrderSiteCommodity,
    pendingLabel,
    personOfContactEditCard,
    pesticideLicensesCard,
    pilotsDropdown,
    premierFeatureCallToAction,
    productDetails,
    productDetailsForm,
    productUsageReportCard,
    productUsageReportDeleteConfirmationModal,
    productUsageReportDropdown,
    productUsageReportFooter,
    productUsageReportListPage,
    productUsageReportListPageLayoutHeader,
    productUsageReportMenu,
    productUsageReportNotes,
    productUsageReportPage,
    productUsageReportPdf,
    productUsageReportStateReportingChemicalsTab,
    productUsageReportSummaryCard,
    productUsageReportSummaryDropdown,
    productUsageReportTable,
    productUsageReportsPage,
    quickBooksConnectionListItem,
    quickBooksImportConfirmationModal,
    quickBooksLabel,
    quickBooksPdfInvoiceView,
    quickbooksDiscountTypeDropdownField,
    quickbooksServiceItemsDropdownField,
    quickbooksTaxCodesDropdownField,
    quickbooksTermsDropdownField,
    quickbooksWarningModal,
    refreshButton,
    saveChangesModal,
    saveReportButton,
    scheduledLabel,
    sendInvoicePage,
    shareToFieldView,
    shareToJohnDeere,
    sideBarContentContainer,
    siteDropdown,
    siteFooter,
    siteForm,
    siteHeader,
    siteListItem,
    siteMultiSelectDropdown,
    startedLabel,
    stripeConfirmationRedirectPage,
    stripeSubscriptionCard,
    stripeSubscriptionSummary,
    subscriptions,
    subtotalSectionForm,
    successLabel,
    syncedLabel,
    tankMixTable,
    tankMixTotals,
    teamDetails,
    teamDetailsTabs,
    textField,
    textInputWithValidation,
    timeZoneField,
    timeoutErrorPage,
    uasTypeAndModel,
    unknownErrorPage,
    uploadFlightLogPage,
    uploadedFileOptions,
    uploadedLabel,
    useAccount,
    useAccountTabs,
    useApplicator,
    useDdm,
    useDroneData,
    useEaVision,
    useFetch,
    useFlightGroups,
    useFlightReportDelete,
    useFlightReportUpdate,
    useInviteUserToOrganization,
    useOperators,
    useQuickBooksConnection,
    useQuickbooksInvoice,
    useStripe,
    useUserRoles,
    userDetailsEditCard,
    userDetailsForm,
    userRolesDropdownField,
    userRolesTable,
    users,
    usersTab,
    usersTable,
    v2AircraftForm,
    v2ApplicatorCertificationForm,
    v2ControllerForm,
    v2EditAircraft,
    v2EditApplicatorCertification,
    v2EditCertifications,
    v2EditCompanyDetails,
    v2EditController,
    v2EditPersonOfContact,
    v2EditPesticideLicense,
    v2EditUserDetails,
    v2FreeTrialBanner,
    v2InviteUser,
    v2MultiSelectDropdown,
    v2NewAircraft,
    v2NewApplicatorCertification,
    v2NewController,
    v2NewPesticideLicense,
    v2PesticideLicenseForm,
    v2SitesPage,
    v2SubscriptionBanner,
    verifyAccountPage,
    verifyEmailPage,
    verifyOrganizationPage,
    versionAvailabilityBanner,
    wetLabel,
    withCharacterCount,
    workOrderApplicationSite,
    workOrderApplicationSiteFields,
    workOrderChemicalInformation,
    workOrderChemicalInformationFields,
    workOrderCustomerInformation,
    workOrderDetails,
    workOrderDropdown,
    workOrderFooter,
    workOrderGrowerInformation,
    workOrderInvoiceAssistant,
    workOrderListPageLayoutHeader,
    workOrderMenu,
    workOrderNotes,
    workOrderNumberInput,
    workOrderPage,
    workOrderReportPDF,
    workOrderReportPage,
    workOrderSidebar,
    workOrderSiteCommodity,
    workOrderTabs,
    workOrders,
    workspaceEditForm,
    xagFileUploadTab,
    yearsOfServiceDropdownField,
    yesNoDropdown
};
